export const SERVER_API_URL = 'https://api.mpp.bright.id/v2';
export const SERVER_SOCKET_URL = 'https://mpp.bright.id:2717';
export const TOKEN_NAME = 'brightMPP';



// WEBPACK FOOTER //
// ./src/app/config.ts